import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {ticketActions} from "./ticketSlice";
import {ticketApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(ticketApi.gets, action.payload);
		yield put(ticketActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch ticket list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(ticketActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(ticketActions.setFilter(action.payload));
}

export default function* ticketSaga() {
	yield takeLatest(ticketActions.fetchData.type, fetchDemoList);
	yield debounce(500, ticketActions.setFilterWithDebounce.type, handleSearchDebounce)
}